export const CLASSES_AND_SPECS = [
  {
    class: "Death Knight",
    color: "#C41E3A",
    icon: "DeathKnight",
    specs: [
      {
        title: "Blood",
      },
      {
        title: "Frost",
      },
      {
        title: "Unholy",
      },
    ],
  },
  {
    class: "Demon Hunter",
    color: "#A330C9",
    icon: "DemonHunter",
    specs: [
      {
        title: "Havoc",
      },
      {
        title: "Vengeance",
      },
      {
        title: "Devourer",
      },
    ],
  },
  {
    class: "Druid",
    color: "#FF7C0A",
    icon: "Druid",
    specs: [
      {
        title: "Balance",
      },
      {
        title: "Feral",
      },
      {
        title: "Guardian",
      },
      {
        title: "Restoration",
      },
    ],
  },
  {
    class: "Evoker",
    color: "#33937F",
    icon: "Evoker",
    specs: [
      {
        title: "Augmentation",
      },
      {
        title: "Devastation",
      },
      {
        title: "Preservation",
      },
    ],
  },
  {
    class: "Hunter",
    color: "#AAD372",
    icon: "Hunter",
    specs: [
      {
        title: "Beast Mastery",
      },
      {
        title: "Marksmanship",
      },
      {
        title: "Survival",
      },
    ],
  },
  {
    class: "Mage",
    color: "#3FC7EB",
    icon: "Mage",
    specs: [
      {
        title: "Arcane",
      },
      {
        title: "Fire",
      },
      {
        title: "Frost",
      },
    ],
  },
  {
    class: "Monk",
    color: "#00FF98",
    icon: "Monk",
    specs: [
      {
        title: "Brewmaster",
      },
      {
        title: "Mistweaver",
      },
      {
        title: "Windwalker",
      },
    ],
  },
  {
    class: "Paladin",
    color: "#F48CBA",
    icon: "Paladin",
    specs: [
      {
        title: "Holy",
      },
      {
        title: "Protection",
      },
      {
        title: "Retribution",
      },
    ],
  },
  {
    class: "Priest",
    color: "#FFFFFF",
    icon: "Priest",
    specs: [
      {
        title: "Discipline",
      },
      {
        title: "Holy",
      },
      {
        title: "Shadow",
      },
    ],
  },
  {
    class: "Rogue",
    color: "#FFF468",
    icon: "Rogue",
    specs: [
      {
        title: "Assassination",
      },
      {
        title: "Outlaw",
      },
      {
        title: "Subtlety",
      },
    ],
  },
  {
    class: "Shaman",
    color: "#0070DD",
    icon: "Shaman",
    specs: [
      {
        title: "Elemental",
      },
      {
        title: "Enhancement",
      },
      {
        title: "Restoration",
      },
    ],
  },
  {
    class: "Warlock",
    color: "#8788EE",
    icon: "Warlock",
    specs: [
      {
        title: "Affliction",
      },
      {
        title: "Demonology",
      },
      {
        title: "Destruction",
      },
    ],
  },
  {
    class: "Warrior",
    color: "#C69B6D",
    icon: "Warrior",
    specs: [
      {
        title: "Arms",
      },
      {
        title: "Fury",
      },
      {
        title: "Protection",
      },
    ],
  },
];

export const CLASSES_FOR_URL = [
  "death_knight",
  "demon_hunter",
  "druid",
  "evoker",
  "hunter",
  "mage",
  "monk",
  "paladin",
  "priest",
  "rogue",
  "shaman",
  "warlock",
  "warrior",
];

// FIRST HERO NAME IS THE LEFT TREE AND SECOND IS THE RIGHT TREE MAPPED TO HOW THE TALENT TREES ARE.
export const SPECS_TO_HERO_TREES = {
  "Death Knight": {
    specs: {
      Blood: ["Deathbringer", "San'layn"],
      Frost: ["Deathbringer", "Rider of the Apocalypse"],
      Unholy: ["Rider of the Apocalypse", "San'layn"],
    },
  },
  "Demon Hunter": {
    specs: {
      Havoc: ["Aldrachi Reaver", "Fel-scarred"],
      Vengeance: ["Aldrachi Reaver", "Annihilator"],
      Devourer: ["Annihilator", "Void-scarred"],
    },
  },
  Druid: {
    specs: {
      Balance: ["Elune's Chosen", "Keeper of the Grove"],
      Feral: ["Druid of the Claw", "Wildstalker"],
      Guardian: ["Druid of the Claw", "Elune's Chosen"],
      Restoration: ["Keeper of the Grove", "Wildstalker"],
    },
  },
  Evoker: {
    specs: {
      Augmentation: ["Chronowarden", "Scalecommander"],
      Devastation: ["Flameshaper", "Scalecommander"],
      Preservation: ["Chronowarden", "Flameshaper"],
    },
  },
  Hunter: {
    specs: {
      "Beast Mastery": ["Dark Ranger", "Pack Leader"],
      Marksmanship: ["Dark Ranger", "Sentinel"],
      Survival: ["Pack Leader", "Sentinel"],
    },
  },
  Mage: {
    specs: {
      Arcane: ["Spellslinger", "Sunfury"],
      Fire: ["Frostfire", "Sunfury"],
      Frost: ["Frostfire", "Spellslinger"],
    },
  },
  Monk: {
    specs: {
      Brewmaster: ["Master of Harmony", "Shado-pan"],
      Mistweaver: ["Conduit of the Celestials", "Master of Harmony"],
      Windwalker: ["Conduit of the Celestials", "Shado-pan"],
    },
  },
  Paladin: {
    specs: {
      Holy: ["Herald of the Sun", "Lightsmith"],
      Protection: ["Lightsmith", "Templar"],
      Retribution: ["Herald of the Sun", "Templar"],
    },
  },
  Priest: {
    specs: {
      Discipline: ["Oracle", "Voidweaver"],
      Holy: ["Oracle", "Archon"],
      Shadow: ["Archon", "Voidweaver"],
    },
  },
  Rogue: {
    specs: {
      Assassination: ["Deathstalker", "Fatebound"],
      Outlaw: ["Fatebound", "Trickster"],
      Subtlety: ["Deathstalker", "Trickster"],
    },
  },
  Shaman: {
    specs: {
      Elemental: ["Farseer", "Stormbringer"],
      Enhancement: ["Stormbringer", "Totemic"],
      Restoration: ["Farseer", "Totemic"],
    },
  },
  Warlock: {
    specs: {
      Affliction: ["Hellcaller", "Soul Harvester"],
      Demonology: ["Diabolist", "Soul Harvester"],
      Destruction: ["Diabolist", "Hellcaller"],
    },
  },
  Warrior: {
    specs: {
      Arms: ["Colossus", "Slayer"],
      Fury: ["Mountain Thane", "Slayer"],
      Protection: ["Colossus", "Mountain Thane"],
    },
  },
};
